import cn from "classnames";
import { withLoadedSettings } from "components/bid/show/partials/planRefueling";
import { Field } from "components/shared/form";
import { bidRefuelingServiceTypesEnum, fuelTankTypes } from "helpers/enums";
import { enumLabel } from "helpers/system";
import React, { useEffect } from "react";

const RefuelingForm = (props) => {
    useEffect(() => {
        const { initialState, carLinked, refuelingServiceType } = props;
        props.setValue({ ...initialState, carLinked, refuelingServiceType });
    }, []);

    const setValue = ({ name, value }, i) => {
        const newValue = props.data.fuelTanks.map((fuelTank, index) =>
            index === i ? { ...fuelTank, [name]: value } : fuelTank,
        );
        props.setValue({ fuelTanks: newValue });
    };

    const renderField = (fieldProps, i) => {
        return (
            <Field
                key={fieldProps.label}
                labelWrapper="col-8 col-form-label col-form-label-sm"
                fieldWrapper="col-4"
                bWrapper="pb-1 row"
                onChange={(data) => {
                    const newValue = data.value ? parseInt(data.value) : "";
                    setValue({ ...data, value: newValue }, i);
                }}
                value={props.data.fuelTanks[i][fieldProps.inputProps.name]}
                {...fieldProps}
            />
        );
    };

    const { config } = props.config.fuelTanks;
    const renderMultiGoFuelTank = (_, index) => {
        return (
            <div key={index} className="pb-3">
                <small className="text-muted">
                    <strong>
                        Топливный бак №{index + 1} - {enumLabel(fuelTankTypes, props.data.fuelTanks[index].type)}
                    </strong>
                </small>
                {renderField(config.currentVolume, index)}
                {renderField(config.fuelConsumption, index)}
            </div>
        );
    };

    const renderFuelTank = (_, index) => {
        return (
            <div key={index} className="pb-3">
                <small className="text-muted">
                    <strong>
                        Топливный бак №{index + 1} - {enumLabel(fuelTankTypes, props.data.fuelTanks[index].type)}
                    </strong>
                </small>
                {renderField(config.fuelConsumption, index)}
                {renderField(config.currentVolume, index)}
                {renderField(config.minimumVolume, index)}
                {renderField(config.totalVolume, index)}
            </div>
        );
    };

    const cname = cn("container", { "book-form__body--invalid": !props.isValid });

    if (props.carLinked) {
        return (
            <div className={cname}>
                {props.refuelingServiceType === bidRefuelingServiceTypesEnum.MultiGo ||
                props.refuelingServiceType === bidRefuelingServiceTypesEnum.MultiGo2
                    ? props.data.fuelTanks.map(renderMultiGoFuelTank)
                    : props.data.fuelTanks.map(renderFuelTank)}
            </div>
        );
    } else {
        return (
            <div className="col-12">
                <div className="alert alert-warning show-bid__without-refueling-wrap">
                    <div className="show-bid__without-refueling-icon--wrapper">
                        <i className="show-bid__without-refueling-icon" />
                    </div>
                    Отключен: расчет топлива
                </div>
            </div>
        );
    }
};

export default withLoadedSettings(RefuelingForm);
